import { Plus } from '@styled-icons/boxicons-regular';
import { ShoppingBag } from '@styled-icons/boxicons-solid';
import classNames from 'classnames';
import ButtonAccent from '../../sharedComponents/Button/ButtonAccent';
import styles from './Products.module.css';

export function EmptyProducts({ createNewProduct }: {
  createNewProduct: () => void
}) {
  return (
    <div className={classNames('card-border', styles.emptyContainer)}>
      <div
        className="container is-flex is-justify-content-center is-align-items-center"
        style={{
          width: 72, height: 72, borderRadius: 10, border: '1px solid #EBEBEB',
        }}
      >
        <ShoppingBag size={48} color="var(--accent)" />
      </div>
      <div className="with-text-color mt-5">Your products will appear here</div>
      <div className="is-subtitle">This is where you&apos;ll manage and create products</div>
      <ButtonAccent onClick={createNewProduct} className="mt-5">
        <Plus size={16} className="mr-2" />
        New Product
      </ButtonAccent>
    </div>
  );
}
